"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Box_1 = require("@material-ui/core/Box");
var Button_1 = require("@material-ui/core/Button");
var Card_1 = require("@material-ui/core/Card");
var CardContent_1 = require("@material-ui/core/CardContent");
var CardMedia_1 = require("@material-ui/core/CardMedia");
var CircularProgress_1 = require("@material-ui/core/CircularProgress");
var Collapse_1 = require("@material-ui/core/Collapse");
var Divider_1 = require("@material-ui/core/Divider");
var Grid_1 = require("@material-ui/core/Grid");
var List_1 = require("@material-ui/core/List");
var ListItem_1 = require("@material-ui/core/ListItem");
var ListItemIcon_1 = require("@material-ui/core/ListItemIcon");
var ListItemText_1 = require("@material-ui/core/ListItemText");
var Typography_1 = require("@material-ui/core/Typography");
var ExpandLess_1 = require("@material-ui/icons/ExpandLess");
var ExpandMore_1 = require("@material-ui/icons/ExpandMore");
var FolderOutlined_1 = require("@material-ui/icons/FolderOutlined");
var TouchApp_1 = require("@material-ui/icons/TouchApp");
var withStyles_1 = require("@material-ui/styles/withStyles");
var graphql_tag_1 = require("graphql-tag");
exports.ProductShowFragmentGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment ProductShowFragment on Book {\n    authors\n    editors\n    description\n    imageUrl(style: $imageStyle)\n    title\n    courses {\n      name\n      director\n      university {\n        name\n      }\n    }\n    product {\n      slug\n      variants {\n        id\n        price\n        isMaster\n        isRental\n      }\n    }\n    tableOfContents(options: { nodeFilter: [Chapter]}) {\n      linkId\n      positionPath\n      title\n      type\n    }\n  }\n"], ["\n  fragment ProductShowFragment on Book {\n    authors\n    editors\n    description\n    imageUrl(style: $imageStyle)\n    title\n    courses {\n      name\n      director\n      university {\n        name\n      }\n    }\n    product {\n      slug\n      variants {\n        id\n        price\n        isMaster\n        isRental\n      }\n    }\n    tableOfContents(options: { nodeFilter: [Chapter]}) {\n      linkId\n      positionPath\n      title\n      type\n    }\n  }\n"])));
var styles = function (theme) { return ({
    paper: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        color: theme.palette.text.secondary
    },
    productContainer: {
        maxWidth: 1024
    },
    productImage: {
        width: 300,
        height: 412,
        backgroundSize: 'contain',
        backgroundPosition: 'top'
    },
    card: {
        borderWidth: 2,
        width: 300
    },
    largeCover: {
        display: 'flex',
        minWidth: 360
    },
    dividerFullWidth: {
        margin: theme.spacing(3) + "px 0 " + theme.spacing(3) + "px 0"
    },
    actions: {
        width: 300,
        marginTop: 24
    },
    cardContent: {
        minWidth: 241,
        marginLeft: '14px'
    },
    chapterList: {
        padding: 0,
        margin: 0
    },
    chapterListItem: {
        margin: 0,
        color: 'rgba(0, 0, 0, 0.54)'
    }
}); };
var CourseBlock = function (_a) {
    var courses = _a.courses;
    if (!courses) {
        return null;
    }
    switch (courses.length) {
        case 0:
            return null;
        case 1:
            var course = courses[0];
            return (React.createElement(React.Fragment, null,
                course.university && (React.createElement(React.Fragment, null,
                    React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "UNIVERSITY"),
                    React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", style: { marginBottom: 10 } }, course.university.name))),
                React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "COURSE"),
                React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", style: { marginBottom: 10 } }, course.name),
                course.director && (React.createElement(React.Fragment, null,
                    React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "DIRECTOR"),
                    React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", style: { marginBottom: 10 } }, course.director)))));
        default:
            var courseList = courses.map(function (c, i) { return (React.createElement("p", { key: c.name || i, style: { margin: '0' } },
                c.university && c.university.name && (React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", component: "span" }, c.university.name + " : ")),
                React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", component: "span" }, c.name),
                c.director && (React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", component: "span" }, " - " + c.director)))); });
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "COURSES"),
                React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", style: { marginBottom: 10 }, component: "div" }, courseList)));
    }
};
var TableOfContents = /** @class */ (function (_super) {
    __extends(TableOfContents, _super);
    function TableOfContents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.toggleIsOpen = function () {
            _this.setState({ isOpen: !_this.state.isOpen });
        };
        return _this;
    }
    TableOfContents.prototype.render = function () {
        var _a = this.props, classes = _a.classes, tableOfContents = _a.tableOfContents;
        if (!tableOfContents || tableOfContents.length === 0) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Divider_1.default, { className: classes.dividerFullWidth }),
            React.createElement(Grid_1.default, { item: true, xs: 12, sm: 12 },
                React.createElement(List_1.default, { component: "nav" },
                    React.createElement(ListItem_1.default, { button: true, onClick: this.toggleIsOpen, className: classes.chapterList },
                        React.createElement(Typography_1.default, { color: "textPrimary", gutterBottom: true, variant: "h5", component: "h5" }, "Table of Contents"),
                        this.state.isOpen ? React.createElement(ExpandLess_1.default, null) : React.createElement(ExpandMore_1.default, null)),
                    React.createElement(Collapse_1.default, { in: this.state.isOpen, timeout: "auto", unmountOnExit: true },
                        React.createElement(List_1.default, { component: "div", disablePadding: true },
                            React.createElement("div", { style: { display: 'block', height: 10 } }),
                            tableOfContents.map(function (tocNode, i) { return (React.createElement(ListItem_1.default, { button: true, className: classes.chapterListItem, key: "toc-chapter-" + tocNode.linkId },
                                React.createElement(ListItemIcon_1.default, null,
                                    React.createElement(FolderOutlined_1.default, null)),
                                React.createElement(ListItemText_1.default, { primary: i + 1 + " - " + tocNode.title }))); })))))));
    };
    return TableOfContents;
}(React.Component));
// tslint:disable-next-line: no-empty
var noopButtonClickListener = function () {
    return function (event) { return console.log('Action Clicked', event); };
};
var VariantType;
(function (VariantType) {
    VariantType[VariantType["RENTAL"] = 0] = "RENTAL";
    VariantType[VariantType["FULL_PRICE"] = 1] = "FULL_PRICE";
})(VariantType = exports.VariantType || (exports.VariantType = {}));
var ProductShow = function (props) {
    var classes = props.classes, book = props.book, _a = props.onAddClickFn, onAddClickFn = _a === void 0 ? noopButtonClickListener : _a, variantBeingPurchased = props.variantBeingPurchased;
    var title = book.title || '';
    var variants = book.product && book.product.variants || [];
    var master = variants.find(function (variant) { return variant.isMaster; });
    var rental = variants.find(function (variant) { return !variant.isMaster && variant.isRental; });
    var price = master && master.price || rental && rental.price;
    var isFullPriceBeingPurchased = variantBeingPurchased === VariantType.FULL_PRICE;
    var isRentalBeingPurchased = variantBeingPurchased === VariantType.RENTAL;
    var isVariantBeingPurchased = isFullPriceBeingPurchased || isRentalBeingPurchased;
    return (React.createElement(Grid_1.default, { container: true, spacing: 4, direction: "row-reverse", className: classes.productContainer },
        React.createElement(Grid_1.default, { item: true, xs: 12, sm: 4 },
            React.createElement(Card_1.default, { className: classes.card },
                book.imageUrl && (React.createElement(CardMedia_1.default, { className: classes.productImage, image: book.imageUrl, title: title })),
                React.createElement(CardContent_1.default, { className: classes.cardContent },
                    React.createElement(Typography_1.default, { variant: "subtitle1", color: "textPrimary", align: "center", style: { marginTop: -20 } },
                        React.createElement(TouchApp_1.default, { style: { marginRight: 14 } }),
                        "INTERACTIVE BOOK"))),
            React.createElement(Grid_1.default, { container: true, spacing: 3, className: classes.actions },
                master && !master.price !== null && (React.createElement(Grid_1.default, { item: true, xs: 12, sm: 12 },
                    React.createElement(Button_1.default, { variant: "contained", color: "primary", size: "large", style: { width: 300 }, onClick: onAddClickFn(master.id, VariantType.FULL_PRICE), disabled: isVariantBeingPurchased },
                        React.createElement(Grid_1.default, { container: true, justify: "center", alignItems: "center" },
                            React.createElement(Grid_1.default, { item: true, style: { width: 0, flexGrow: 0 } }, isFullPriceBeingPurchased && React.createElement(CircularProgress_1.default, { style: { verticalAlign: 'middle' }, size: 20 })),
                            React.createElement(Grid_1.default, { item: true, style: { flexGrow: 1 } }, "Add to Cart"))))) || null,
                rental && rental.price != null && (React.createElement(Grid_1.default, { item: true, xs: 12, sm: 12 },
                    React.createElement(Button_1.default, { variant: "outlined", size: "large", color: "primary", style: { width: 300 }, onClick: onAddClickFn(rental.id, VariantType.RENTAL), disabled: isVariantBeingPurchased },
                        React.createElement(Grid_1.default, { container: true, justify: "center", alignItems: "center" },
                            React.createElement(Grid_1.default, { item: true, style: { width: 0, flexGrow: 0 } }, isRentalBeingPurchased && React.createElement(CircularProgress_1.default, { style: { verticalAlign: 'middle' }, size: 20 })),
                            React.createElement(Grid_1.default, { item: true, style: { flexGrow: 1 } },
                                "Rent $", "" + rental.price.toFixed(2)))))) || null)),
        React.createElement(Grid_1.default, { item: true, xs: 12, sm: 8, className: classes.largeCover, direction: "column" },
            React.createElement(Grid_1.default, { item: true },
                React.createElement(Box_1.default, null,
                    React.createElement(Typography_1.default, { gutterBottom: true, variant: "h3", color: "textPrimary" }, title),
                    React.createElement(CourseBlock, { courses: book.courses }),
                    book.editors && (React.createElement(React.Fragment, null,
                        React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "EDITORS"),
                        React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary", style: { marginBottom: 10 } }, book.editors))),
                    book.authors && (React.createElement(React.Fragment, null,
                        React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "AUTHORS"),
                        React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary" }, book.authors))),
                    price && (React.createElement(React.Fragment, null,
                        React.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary" }, "PRICE"),
                        React.createElement(Typography_1.default, { variant: "body1", color: "textPrimary" },
                            "$",
                            price.toFixed(2)))))),
            book.description && (React.createElement(React.Fragment, null,
                React.createElement(Divider_1.default, { className: classes.dividerFullWidth }),
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Box_1.default, null,
                        React.createElement(Typography_1.default, { gutterBottom: true, variant: "h5", component: "h5", color: "textPrimary" }, "Description"),
                        React.createElement(Typography_1.default, { variant: "body1", color: "textSecondary" }, book.description.split('\n').map(function (line) { return (React.createElement(React.Fragment, { key: line },
                            paddInitialWhitespace(line),
                            React.createElement("br", null))); })))))),
            React.createElement(TableOfContents, { classes: classes, tableOfContents: book.tableOfContents }))));
};
function paddInitialWhitespace(original) {
    var result = original.slice(0);
    for (var index = 0; index < result.length; index++) {
        if (result[index] !== ' ') {
            break;
        }
        result = result.substring(0, index) + '\u00a0' + result.substring(index + 1);
    }
    return result;
}
exports.default = withStyles_1.default(styles)(ProductShow);
var templateObject_1;
